import styled from "styled-components";
import { device } from "../../stylesheet/breakpoints";

export const Box = styled.div`
display: flex;

  @media ${device.mobile} {
    flex-direction: column;
    position: relative;
    min-height: 100%;
  }

  @media ${device.desktop} {
    flex-direction: row;
    justify-content: space-between;
    height: 100%;
  }
`;
